!(function (t) {
  'use strict';
  var e = 'trademarkHeaderSearch',
    i = 'plugin_' + e;
  function a(e) {
    (this.headerSearch = t(e)),
      (this.headerSearchForm = this.headerSearch.find('.header-search__form')),
      (this.headerInput = this.headerSearch.find('.header-search__input')),
      (this.headerSearchResults = this.headerSearch.find(
        '.header-search__results-wrapper'
      )),
      (this.searchResultsTemplate = Template7.compile(
        t('#search-results-template').html()
      )),
      (this.searchMode = 'product,article,page'),
      (this.body = t('body')),
      (this.pageOverlay = t('.page__overlay')),
      (this.sidebarNavInstance = t('.sidebar-nav').data(
        'plugin_trademarkMobileSidebar'
      )),
      (this.miniCartInstance = t('.mini-cart').data(
        'plugin_trademarkMiniCart'
      )),
      t('[data-action="open-search"]').on(
        'click',
        t.proxy(this._openSearch, this)
      ),
      t('[data-action="close-search"]').on(
        'click',
        t.proxy(this._closeSearch, this)
      ),
      this.headerInput.on('keyup', t.proxy(this._initSearch, this)),
      this.headerInput.on('focus', t.proxy(this._inputFocused, this)),
      this.headerSearchForm.on('submit', t.proxy(this._formSubmitted, this));
  }
  (a.prototype.destroy = function () {
    t('[data-action="open-search"]').off('click'),
      t('[data-action="close-search"]').off('click'),
      this.headerSearch.removeData('plugin_trademarkHeaderSearch'),
      this.headerInput.off('keyup'),
      this.headerSearchForm.off('submit'),
      this.body.off('.trademarkHeaderSearch');
  }),
    (a.prototype._openSearch = function (e) {
      e || (e = t.Event('open-search'));
      var i = this;
      if (this.headerSearch.hasClass('header-search--open'))
        return void (e.preventDefault && e.preventDefault());
      'opening' === this.sidebarNavInstance.state ||
      'opened' === this.sidebarNavInstance.state
        ? (this.sidebarNavInstance._toggleSidebar(e),
          t(document).one('closed.trademarkMobileSidebar', function () {
            i._doOpenSearch();
          }))
        : 'opening' === this.miniCartInstance.state ||
          'opened' === this.miniCartInstance.state
        ? (this.miniCartInstance._toggleMiniCart(e),
          t(document).one('closed.trademarkMiniCart', function () {
            i._doOpenSearch();
          }))
        : this._doOpenSearch(),
        e.preventDefault && e.preventDefault();
    }),
    (a.prototype._inputFocused = function (t) {
      this.headerSearch.hasClass('header-search--open') ||
        this._openSearch(t);
    }),
    (a.prototype._closeSearch = function (t) {
      this.body.removeClass('no-scroll'),
        this.pageOverlay.removeClass('page__overlay--open'),
        this.headerSearch.removeClass('header-search--open'),
        this.headerSearchResults.empty(),
        this.body.off('.trademarkHeaderSearch'),
        this.pageOverlay.off('.trademarkHeaderSearch'),
        t && t.preventDefault();
    }),
    (a.prototype._doOpenSearch = function () {
      var e = this,
        i = Modernizr.mq('(max-width: 559px)');
      i
        ? (this.body.removeClass('no-scroll'),
          this.pageOverlay.removeClass('page__overlay--open'),
          this.pageOverlay.off('.trademarkHeaderSearch'))
        : (this.body.addClass('no-scroll'),
          this.pageOverlay
            .addClass('page__overlay--open')
            .off('.trademarkHeaderSearch')
            .on('click.trademarkHeaderSearch', function (t) {
              e._closeSearch(t);
            })),
        this.headerSearch.addClass('header-search--open'),
        this.headerSearch.one('transitionend', function () {
          e._cursorFocus(e.headerInput);
        }),
        this.body.on('keyup.trademarkHeaderSearch', function (t) {
          27 == t.keyCode && e._closeSearch(t);
        }),
        this.body.on('click.trademarkHeaderSearch', function (i) {
          var a = t(i.target);
          (a.closest('.header-search__form').length ||
            a.closest('.header-search__results-wrapper').length) ||
            e._closeSearch(i);
        });
    }),
    (a.prototype._initSearch = function (e) {
      var i = t(e.currentTarget);
      clearTimeout(i.data('timeout')),
        i.data('timeout', setTimeout(t.proxy(this._doSearch, this), 250));
    }),
    (a.prototype._doSearch = function (t) {
      Modernizr.mq('(max-width: 559px)') ||
        ('' !== this.headerInput.val()
          ? (this.headerSearchResults.html(
              this.searchResultsTemplate({ is_loading: !0 })
            ),
            'product' === this.searchMode
              ? this._doCompleteSearch()
              : this._doSeparateSearch())
          : this.headerSearchResults.empty());
    }),
    (a.prototype._doCompleteSearch = function (e) {
      var i = this;
      t.ajax({
        method: 'GET',
        url: '/search?view=json',
        dataType: 'json',
        data: {
          q: this.headerInput.val() + '*  -tag:wholesale_only',
          type: this.searchMode,
        },
      }).then(function (t) {
        i.headerSearchResults.html(
          i.searchResultsTemplate({
            is_loading: !1,
            split_search: !1,
            on_sale_label: window.languages.productLabelsOnSale,
            results: t.results,
            has_results: t.results.length > 0,
            results_count: t.results_count,
            results_label: t.results_label,
            results_url: t.url + '&type=' + i.searchMode,
          })
        );
      });
    }),
    (a.prototype._doSeparateSearch = function (e) {
      var i = this.searchMode.split(','),
        a = this,
        o = t.ajax({
          method: 'GET',
          url: '/search?view=json',
          dataType: 'json',
          data: {
            q: this.headerInput.val() + '*  -tag:wholesale_only',
            type: i[0],
          },
        }),
        s = t.ajax({
          method: 'GET',
          url: '/search?view=json',
          dataType: 'json',
          data: {
            q: this.headerInput.val() + '*  -tag:wholesale_only',
            type: i.slice(1).join(','),
          },
        });
      t.when(o, s).then(function (t, e) {
        a.headerSearchResults.html(
          a.searchResultsTemplate({
            is_loading: !1,
            split_search: !0,
            on_sale_label: window.languages.productLabelsOnSale,
            has_products_results: t[0].results.length > 0,
            has_others_results: e[0].results.length > 0,
            products: {
              results: t[0].results,
              results_count: t[0].results_count,
              results_label: t[0].results_label,
              results_url: t[0].url + '&type=' + i[0],
            },
            others: {
              results: e[0].results,
              results_count: e[0].results_count,
              results_label: e[0].results_label,
              results_url: e[0].url + '&type=' + i.slice(1).join(','),
            },
          })
        );
      });
    }),
    (a.prototype._formSubmitted = function (t) {
      return this.headerInput.val(this.headerInput.val() + '*'), !0;
    }),
    (a.prototype._cursorFocus = function (t) {
      var e = window.scrollX,
        i = window.scrollY;
      t.focus(), window.scrollTo(e, i);
    }),
    (t.fn[e] = function (e) {
      var o = !1,
        s = arguments;
      return (
        'string' == typeof e && (o = e),
        this.each(function () {
          var n = t.data(this, i);
          n || o
            ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
            : t.data(this, i, new a(this, e));
        })
      );
    });
})(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkHomeSlideshow',
      i = 'plugin_' + e;
    function a(e) {
      (this.slideshow = t(e)),
        (this.slideshowAnchor = this.slideshow.find('.slideshow--anchor')),
        (this.slideshowAnchorSlides =
          this.slideshowAnchor.find('.slideshow__slide')),
        (this.slideshowMain = this.slideshow.find('.slideshow--main')),
        (this.slideshowMainSlides =
          this.slideshowMain.find('.slideshow__slide')),
        (this.slideshowSlidesCount = this.slideshowMainSlides.length),
        (this.slideshowCount = this.slideshow.find(
          '.slideshow__current-slide'
        )),
        (this.slideshowButtons = this.slideshow.find('.slideshow__nav-button')),
        (this.hasTransitionPending = !1),
        (this.paused = !1),
        this.slideshow
          .find('.slideshow__nav-next')
          .on('click', t.proxy(this.nextSlide, this)),
        this.slideshow
          .find('.slideshow__nav-prev')
          .on('click', t.proxy(this.prevSlide, this)),
        this.slideshow.on('swipeleft', t.proxy(this.nextSlide, this)),
        this.slideshow.on('swiperight', t.proxy(this.prevSlide, this)),
        (this.hasAutoplay = 'true' === this.slideshow.attr('data-autoplay')),
        (this.autoplayCycleSpeed = parseInt(
          this.slideshow.attr('data-cycle-speed')
        )),
        this.hasAutoplay && this._setupAutoplay();
      var i = this.slideshowMainSlides.eq(0);
      this._didChange(i, i),
        (this.players =
          plyr.setup(this.slideshowMain.find('.plyr-video[data-type]'), {
            controls: ['play-large'],
            iconPrefix: 'icon-video',
          }) || []);
      var a = this;
      this.players.forEach(function (e) {
        e.on('play', t.proxy(a._videoStarted, a)),
          e.on('pause ended', t.proxy(a._videoEnded, a));
      });
    }
    (a.prototype.destroy = function () {
      this.slideshow.off('swipeleft swiperight'),
        this.slideshowButtons.off('click'),
        clearInterval(this.timer),
        this.players.forEach(function (t) {
          t.destroy();
        }),
        this.slideshow.removeData('plugin_trademarkHomeSlideshow');
    }),
      (a.prototype.nextSlide = function () {
        var t = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
          e = t.next('.slideshow__slide'),
          i = this.slideshowMainSlides.filter('.slideshow__slide--active'),
          a = i.next('.slideshow__slide');
        return (
          0 === e.length && (e = this.slideshowAnchorSlides.first()),
          0 === a.length &&
            (a = 0 !== a.length ? a : this.slideshowMainSlides.first()),
          this._move(t, e, i, a, 'next'),
          !1
        );
      }),
      (a.prototype.prevSlide = function () {
        var t = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
          e = t.prev('.slideshow__slide'),
          i = this.slideshowMainSlides.filter('.slideshow__slide--active'),
          a = i.prev('.slideshow__slide');
        return (
          0 === e.length && (e = this.slideshowAnchorSlides.last()),
          0 === a.length &&
            (a = 0 !== a.length ? a : this.slideshowMainSlides.last()),
          this._move(t, e, i, a, 'previous'),
          !1
        );
      }),
      (a.prototype.goToSlide = function (t) {
        var e = parseInt(t) - 1,
          i = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
          a = this.slideshowAnchorSlides.eq(
            0 === e ? 1 : (e + 1) % this.slideshowSlidesCount
          ),
          o = this.slideshowMainSlides.filter('.slideshow__slide--active'),
          s = this.slideshowMainSlides.eq(e),
          n = this.slideshowMainSlides.index(o);
        if (n !== e)
          return this._move(i, a, o, s, n > e ? 'previous' : 'next'), !1;
      }),
      (a.prototype.pause = function () {
        this.paused = !0;
      }),
      (a.prototype.play = function () {
        this.paused = !1;
      }),
      (a.prototype._move = function (t, e, i, a, o) {
        if (!this.hasTransitionPending) {
          this.hasAutoplay && !this.paused && this._clearAutoplay();
          var s = this;
          if (
            (this.slideshowButtons.attr('disabled', 'disabled'),
            this._willChange(i, a),
            Modernizr.cssanimations)
          ) {
            var n =
              'slideshow__slide--animating ' +
              ('next' === o
                ? 'slideshow__slide--animating-rtl'
                : 'slideshow__slide--animating-ltr');
            e.addClass(n),
              a.addClass(n),
              i.addClass('slideshow__slide--removing'),
              t.addClass('slideshow__slide--removing'),
              e
                .find('.slideshow__media-container')
                .one('webkitAnimationEnd animationend', function () {
                  e.removeClass(n).addClass('slideshow__slide--active'),
                    t.removeClass(
                      'slideshow__slide--active slideshow__slide--removing'
                    );
                }),
              a
                .find('.slideshow__media')
                .one('webkitAnimationEnd animationend', function () {
                  a.removeClass(n).addClass('slideshow__slide--active'),
                    i.removeClass(
                      'slideshow__slide--active slideshow__slide--removing'
                    ),
                    s.slideshowCount.text(a.attr('data-slide-index')),
                    s.slideshowButtons.removeAttr('disabled'),
                    s._didChange(i, a);
                });
          } else
            e.addClass('slideshow__slide--active'),
              t.removeClass('slideshow__slide--active'),
              a.addClass('slideshow__slide--active'),
              i.removeClass('slideshow__slide--active'),
              this.slideshowCount.text(a.attr('data-slide-index')),
              this.slideshowButtons.removeAttr('disabled'),
              this._didChange(i, a);
        }
      }),
      (a.prototype._willChange = function (t, e) {
        (this.hasTransitionPending = !0),
          t.hasClass('slideshow__slide--video') &&
            plyr.get(t.get(0))[0].pause();
      }),
      (a.prototype._didChange = function (t, e) {
        (this.hasTransitionPending = !1),
          this.hasAutoplay && !this.paused && this._setupAutoplay();
      }),
      (a.prototype._setupAutoplay = function () {
        var t = this;
        this._clearAutoplay(),
          (this.timer = setInterval(function () {
            t.paused || t.nextSlide();
          }, this.autoplayCycleSpeed));
      }),
      (a.prototype._clearAutoplay = function () {
        this.timer && clearInterval(this.timer), (this.timer = null);
      }),
      (a.prototype._videoStarted = function () {
        this.hasAutoplay && (this.paused = !0),
          this.slideshowMain.addClass('slideshow--video-playing');
      }),
      (a.prototype._videoEnded = function () {
        this.hasAutoplay && (this.paused = !1),
          this.slideshowMain.removeClass('slideshow--video-playing');
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
  })(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkInstagram',
      i = 'plugin_' + e;
    function a(e) {
      ((this.element = t(e)),
      (this.hasTransitionPending = !1),
      (this.accessToken = this.element.attr('data-access-token')),
      this.accessToken) &&
        new Instafeed({
          get: 'user',
          userId: 'self',
          accessToken: this.accessToken,
          sortBy: 'most-recent',
          limit: 15,
          resolution: Modernizr.mq('(max-width: 500px)')
            ? 'low_resolution'
            : 'standard_resolution',
          success: t.proxy(this._imagesLoaded, this),
          mock: function () {},
        }).run();
      this.element.on(
        'click',
        '.instagram-tile__button--prev',
        t.proxy(this._move, this, 'prev')
      ),
        this.element.on(
          'click',
          '.instagram-tile__button--next',
          t.proxy(this._move, this, 'next')
        ),
        this.element.on('swiperight', t.proxy(this._move, this, 'prev')),
        this.element.on('swipeleft', t.proxy(this._move, this, 'next'));
    }
    (a.prototype.destroy = function () {
      this.element.find('.instagram-tile__button').off('click'),
        this.element.off('swipeleft swiperight'),
        this.element.removeData('plugin_trademarkInstagram');
    }),
      (a.prototype._imagesLoaded = function (t) {
        for (var e = t.data; e.length < 15; ) e = e.concat(e);
        e = e.slice(0, 15);
        var i = Math.round(e.length / 2),
          a = e.splice(i),
          o = e.slice();
        a.reverse().forEach(function (t) {
          o.unshift(t);
        });
        for (var s = '', n = 0; n !== o.length; ++n) {
          var r = 0 === n ? o.length - 1 : n - 1,
            d = n === o.length - 1 ? 0 : n + 1;
          s =
            s +
            '<div class="instagram__tile-wrapper ' +
            (n === i - 1 ? 'instagram__tile-wrapper--featured' : '') +
            '"><button class="instagram-tile__button instagram-tile__button--prev"><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>' +
            ('<div class="instagram__tile-wrapper-hidder">' +
              this._renderTile(o[r], 'instagram-tile--prev') +
              this._renderTile(o[n], 'instagram-tile--active') +
              this._renderTile(o[d], 'instagram-tile--next') +
              '</div>') +
            '<button class="instagram-tile__button instagram-tile__button--next"><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button></div>';
        }
        this.element.html(s);
      }),
      (a.prototype._renderTile = function (t, e) {
        var i = t.caption ? t.caption.text : '';
        return (
          (i = i.length > 95 ? i.substring(0, 95) + '...' : i),
          '<div class="instagram-tile ' +
            e +
            '"><a href="' +
            t.link +
            '" class="instagram-tile__image-wrapper" target="_blank" style="background-image: url(' +
            t.images.standard_resolution.url +
            ')"></a><div class="instagram-tile__info"><div class="instagram-tile__info-wrapper"><div class="instagram-tile__meta"><p class="instagram-tile__likes"><svg class="icon icon-heart"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-heart"></use></svg>' +
            t.likes.count +
            '</p><div class="instagram-tile__caption rte">' +
            i +
            '</div></div><time class="instagram-tile__date text--uppercase">' +
            this._formatDate(t.created_time) +
            '</time></div></div></div>'
        );
      }),
      (a.prototype._formatDate = function (t) {
        var e = new Date(1e3 * t),
          i = e.getMonth(),
          a = e.getDate(),
          o = e.getFullYear();
        return (
          [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ][i] +
          ' ' +
          a +
          ', ' +
          o
        );
      }),
      (a.prototype._move = function (e, i) {
        this.hasTransitionPending ||
          ((this.hasTransitionPending = !0),
          this.element
            .find('.instagram-tile__button')
            .attr('disabled', 'disabled'),
          this.element.addClass('instagram-feed--animating-' + e),
          Modernizr.cssanimations
            ? this.element.on(
                'webkitAnimationEnd animationend',
                t.proxy(this._finishTransition, this, e)
              )
            : this._finishTransition(e),
          i.preventDefault());
      }),
      (a.prototype._finishTransition = function (e, i) {
        if (
          !Modernizr.cssanimations ||
          ('instagramTileAnimation' === i.originalEvent.animationName &&
            0 !==
              t(i.target).closest('.instagram__tile-wrapper--featured').length)
        ) {
          var a = this.element.find('.instagram__tile-wrapper');
          'next' === e
            ? (this.element.append(a.first().detach()),
              a
                .filter('.instagram__tile-wrapper--featured')
                .removeClass('instagram__tile-wrapper--featured')
                .next()
                .addClass('instagram__tile-wrapper--featured'))
            : (this.element.prepend(a.last().detach()),
              a
                .filter('.instagram__tile-wrapper--featured')
                .removeClass('instagram__tile-wrapper--featured')
                .prev()
                .addClass('instagram__tile-wrapper--featured')),
            this.element.find('.instagram-tile__button').removeAttr('disabled'),
            this.element.removeClass('instagram-feed--animating-' + e),
            this.element.off('webkitAnimationEnd animationend'),
            (this.hasTransitionPending = !1);
        }
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
  })(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkMainNav',
      i = 'plugin_' + e;
    function a(e) {
      (this.mainNav = t(e)),
        (this.mainNavLinks = this.mainNav.find('.header__link')),
        this.mainNavLinks.on('focusin', function () {
          t(this).addClass('header__link--focused');
        }),
        this.mainNavLinks.on('focusout', function () {
          t(this).removeClass('header__link--focused');
        }),
        this.mainNav.hasClass('header__main-nav--stretched') ||
          ((this.mainNavWidth = Math.ceil(this.mainNav.width() + 35)),
          this._verifyOverlap(),
          t(window).on(
            'resize.trademarkMainNav',
            t.proxy(this._verifyOverlap, this)
          ));
    }
    (a.prototype.destroy = function () {
      this.mainNavLinks.off('focusin focusout'),
        this.mainNav.removeData('plugin_trademarkMainNav'),
        t(window).off('.trademarkMainNav');
    }),
      (a.prototype._verifyOverlap = function () {
        this.mainNavWidth >
        Math.ceil(
          t('.header__logo').position().left -
            t('.header__inner').position().left
        )
          ? (this.mainNav.hide(),
            t('.header__nav-toggle').removeClass('hidden-desk'))
          : (this.mainNav.show(),
            t('.header__nav-toggle').addClass('hidden-desk')),
          t('.header').addClass('header--init');
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
  })(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkMiniCart',
      i = 'plugin_' + e;
    function a(e) {
      (this.miniCart = t(e)),
        (this.announcementBar = t('.announcement-bar')),
        (this.header = t('.header')),
        (this.headerCartCount = t('.header__cart-count')),
        (this.sidebarNav = t('.sidebar-nav')),
        (this.state = 'closed'),
        (this.body = t('body')),
        (this.pageOverlay = t('.page__overlay')),
        this.body.on(
          'click keypress',
          '[data-action="toggle-mini-cart"]',
          t.proxy(this._toggleMobileCart, this)
        ),
        this.body.on(
          'click keypress',
          '[data-action="desktop-toggle-cart-nav"]',
          t.proxy(this._toggleMiniCartNav, this)
        ),
        this.body.on(
          'click keypress',
          '.page__overlay--open',
          t.proxy(this._toggleMiniCartOutside, this)
        ),
        this.miniCart.on(
          'click',
          '[data-action="remove-line-item"]',
          t.proxy(this._removeLine, this)
        ),
        t(document).on('theme:cart:updated', t.proxy(this._cartUpdated, this)),
        t(window).on(
          'resize.trademarkMiniCart',
          t.proxy(this._computeMiniCartHeight, this)
        ),
        this._rerender(),
        Modernizr.csstransitions &&
          this.miniCart.on(
            'transitionend',
            t.proxy(this._emitTransitionEvent, this)
          );
    }
    (a.prototype.destroy = function () {
      this.miniCart.removeData('plugin_trademarkMiniCart'),
        this.miniCart.find('[data-action="remove-line-item"]').off('click'),
        this.body.off('.trademarkMiniCart'),
        t(document).off('theme:cart:updated'),
        t(window).off('.trademarkMiniCart');
    }),
      (a.prototype.getState = function () {
        return this.state;
      }),
      (a.prototype._toggleMiniCartNav = function (e) {
        var i = this;
        if (
          (13 == (e.keyCode ? e.keyCode : e.which) && e.preventDefault(),
          this._computeMiniCartHeight(),
          this.miniCart.toggleClass('mini-cart--open'),
          this.miniCart.hasClass('mini-cart--open'))
        ) {
          var a = this.sidebarNav.data('plugin_trademarkMobileSidebar');
          ('opening' !== a.state && 'opened' !== a.state) ||
            a._toggleSidebar(e),
            (this.state = 'opening'),
            t(document).trigger('opening.trademarkMiniCart'),
            this.body.addClass('no-scroll'),
            this.pageOverlay.addClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'opened'),
              t(document).trigger('opened.trademarkMiniCart')),
            this.miniCart.one('transitionend', function () {
              i.miniCart.focus();
            }),
            this.body.on('keyup.trademarkMiniCart', function (t) {
              27 == t.keyCode && i._toggleMiniCart(t);
            }),
            this.body.on('click.trademarkMiniCart', function (e) {
              t(e.target).closest('#shopify-section-header').length ||
                i._toggleMiniCart(e);
            });
        } else
          (this.state = 'closing'),
            t(document).trigger('closing.trademarkMiniCart'),
            this.body.removeClass('no-scroll'),
            this.body.off('.trademarkMiniCart'),
            this.pageOverlay.removeClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'closed'),
              t(document).trigger('closed.trademarkMiniCart'));
        e.preventDefault();
      }),
      (a.prototype._toggleMobileCart = function (e) {
        var i = this;
        if (
          (13 == (e.keyCode ? e.keyCode : e.which) && e.preventDefault(),
          this._computeMiniCartHeight(),
          this.miniCart.toggleClass('mini-cart--open'),
          this.miniCart.hasClass('mini-cart--open'))
        ) {
          var a = this.sidebarNav.data('plugin_trademarkMobileSidebar');
          ('opening' !== a.state && 'opened' !== a.state) ||
            a._toggleSidebar(e),
            (this.state = 'opening'),
            t(document).trigger('opening.trademarkMiniCart'),
            this.body.addClass('no-scroll'),
            this.pageOverlay.addClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'opened'),
              t(document).trigger('opened.trademarkMiniCart')),
            this.miniCart.one('transitionend', function () {
              i.miniCart.focus();
            }),
            this.body.on('keyup.trademarkMiniCart', function (t) {
              27 == t.keyCode && i._toggleMiniCart(t);
            }),
            this.body.on('click.trademarkMiniCart', function (e) {
              t(e.target).closest('#shopify-section-header').length ||
                i._toggleMiniCart(e);
            });
        } else
          (this.state = 'closing'),
            t(document).trigger('closing.trademarkMiniCart'),
            this.body.removeClass('no-scroll'),
            this.body.off('.trademarkMiniCart'),
            this.pageOverlay.removeClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'closed'),
              t(document).trigger('closed.trademarkMiniCart'));
        e.preventDefault();
      }),
      (a.prototype._toggleMiniCartOutside = function (t) {
        this.miniCart.removeClass('mini-cart--open'),
          this.body.removeClass('no-scroll'),
          this.pageOverlay.removeClass('page__overlay--open'),
          t.preventDefault();
      }),
      (a.prototype._toggleMiniCart = function (e) {
        var i = this;
        if (
          (13 == (e.keyCode ? e.keyCode : e.which) && e.preventDefault(),
          this._computeMiniCartHeight(),
          this.miniCart.hasClass('mini-cart--open'))
        ) {
          var a = this.sidebarNav.data('plugin_trademarkMobileSidebar');
          ('opening' !== a.state && 'opened' !== a.state) ||
            a._toggleSidebar(e),
            (this.state = 'opening'),
            t(document).trigger('opening.trademarkMiniCart'),
            this.body.addClass('no-scroll'),
            this.pageOverlay.addClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'opened'),
              t(document).trigger('opened.trademarkMiniCart')),
            this.miniCart.one('transitionend', function () {
              i.miniCart.focus();
            }),
            this.body.on('keyup.trademarkMiniCart', function (t) {
              27 == t.keyCode && i._toggleMiniCart(t);
            }),
            this.body.on('click.trademarkMiniCart', function (e) {
              t(e.target).closest('#shopify-section-header').length ||
                i._toggleMiniCart(e);
            });
        } else
          (this.state = 'closing'),
            t(document).trigger('closing.trademarkMiniCart'),
            this.body.removeClass('no-scroll'),
            this.body.off('.trademarkMiniCart'),
            this.pageOverlay.removeClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'closed'),
              t(document).trigger('closed.trademarkMiniCart'));
        e.preventDefault();
      }),
      (a.prototype._cartUpdated = function (t, e, i, a) {
        this.headerCartCount.text(e.item_count),
          a || 0 === e.item_count
            ? this._rerender()
            : this.miniCart
                .find('.mini-cart__total-price')
                .replaceWith(
                  '<span class="mini-cart-item__price mini-cart__total-price" data-money-convertible>' +
                    Shopify.formatMoney(
                      e.total_price,
                      window.shop.moneyFormat
                    ) +
                    '</span>'
                ),
          i && this._toggleMiniCart(t);
      }),
      (a.prototype._removeLine = function (e) {
        var i = t(e.currentTarget),
          a = i.attr('data-variant-id'),
          o = i.closest('.mini-cart__item-wrapper'),
          s = i.closest('.mini-cart__items');
        s.addClass('mini-cart__items--loading'),
          t
            .ajax({
              method: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: { quantity: 0, id: a },
            })
            .then(function (e) {
              s.removeClass('mini-cart__items--loading'),
                o.slideUp(250, function () {
                  t(this).remove();
                }),
                t('.header__cart-count').html(e.item_count),
                t(document).trigger('theme:cart:updated', [e, !1, !1]);
            }),
          e.preventDefault();
      }),
      (a.prototype._rerender = function () {
        var e = this;
        t.ajax('/cart?view=mini-cart').then(function (i) {
          var a = t(i);
          a.attr('data-cart-item-count');
          e.miniCart
            .find('.mini-cart__inner')
            .replaceWith(a.find('.mini-cart__inner')),
            e._computeMiniCartHeight();
        });
      }),
      (a.prototype._computeMiniCartHeight = function () {
        var e = 0,
          i = this.header.outerHeight();
        if (this.announcementBar.length > 0) {
          var a = this.announcementBar.height(),
            o = t(window).height(),
            s = this.announcementBar[0].getBoundingClientRect();
          e = Math.max(
            0,
            s.top > 0 ? Math.min(a, o - s.top) : s.bottom < o ? s.bottom : o
          );
        }
        this.miniCart
          .find('.mini-cart__inner')
          .css('max-height', window.innerHeight - i - e + 'px');
      }),
      (a.prototype._emitTransitionEvent = function (e) {
        'transform' === e.originalEvent.propertyName &&
          ('opening' === this.state || 'opened' === this.state
            ? ((this.state = 'opened'),
              t(document).trigger('opened.trademarkMiniCart'))
            : ((this.state = 'closed'),
              t(document).trigger('closed.trademarkMiniCart')));
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
  })(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkMobileSidebar',
      i = 'plugin_' + e;
    function a(e) {
      (this.sidebarNav = t(e)),
        (this.announcementBar = t('.announcement-bar')),
        (this.header = t('.header')),
        (this.headerNavToggle = this.header.find(
          '[data-action="toggle-mobile-sidebar"]'
        )),
        (this.miniCart = t('.mini-cart')),
        (this.state = 'closed'),
        (this.body = t('body')),
        (this.pageOverlay = t('.page__overlay')),
        this.headerNavToggle.on(
          'click.trademarkMobileSidebar',
          t.proxy(this._toggleSidebar, this)
        ),
        this.sidebarNav.on(
          'click.trademarkMobileSidebar',
          '[data-action="toggle-mobile-sub-menu"]',
          t.proxy(this._toggleSubMenu, this)
        );
        t(window).on(
          'resize.trademarkMobileSidebar',
          t.proxy(this._computeSidebarHeight, this)
        ),
        Modernizr.csstransitions &&
          this.sidebarNav.on(
            'transitionend',
            t.proxy(this._emitTransitionEvent, this)
          );
// Back link: click + keyboard (Enter/Space)
this.sidebarNav.on(
  'click.trademarkMobileSidebar',
  '.sidebar-nav__link-back',
  t.proxy(this._backFromSubMenu, this)
);
this.sidebarNav.on(
  'keydown.trademarkMobileSidebar',
  '.sidebar-nav__link-back',
  t.proxy(function (ev) {
    var k = ev.key || ev.keyCode;
    if (k === 'Enter' || k === ' ' || k === 13 || k === 32) {
      ev.preventDefault();
      this._backFromSubMenu(ev);
    }
  }, this)
);

    }
    (a.prototype.destroy = function () {
      this.header.find('[data-action="toggle-mobile-sidebar"]').off('click'),
      this.sidebarNav.off('click.trademarkMobileSidebar', '[data-action="toggle-mobile-sub-menu"]');
        this.body.off('.trademarkMobileSidebar'),
        t(window).off('.trademarkMobileSidebar'),
        this.sidebarNav.removeData('plugin_trademarkMobileSidebar');
    }),
      (a.prototype.getState = function () {
        return this.state;
      }),
      (a.prototype._toggleSidebar = function (e) {
        var i = this;
        if (
          (this.headerNavToggle.toggleClass('header__nav-toggle--open'),
          this._computeSidebarHeight(),
          this.sidebarNav.toggleClass('sidebar-nav--open'),
          this.sidebarNav.hasClass('sidebar-nav--open'))
        ) {
          var a = this.miniCart.data('plugin_trademarkMiniCart');
          ('opening' !== a.state && 'opened' !== a.state) ||
            a._toggleMiniCart(e),
            (this.state = 'opening'),
            t(document).trigger('opening.trademarkMobileSidebar'),
            this.body.addClass('no-scroll'),
            this.pageOverlay.addClass('page__overlay--open'),
            this.body.on('click.trademarkMobileSidebar', function (e) {
              t(e.target).closest('#shopify-section-header').length ||
                i._toggleSidebar(e);
            }),
            Modernizr.csstransitions ||
              ((this.state = 'opened'),
              t(document).trigger('opened.trademarkMobileSidebar'));
        } else
          (this.state = 'closing'),
            t(document).trigger('closing.trademarkMobileSidebar'),
            this.body.removeClass('no-scroll'),
            this.body.off('.trademarkMobileSidebar'),
            this.pageOverlay.removeClass('page__overlay--open'),
            Modernizr.csstransitions ||
              ((this.state = 'closed'),
              t(document).trigger('closed.trademarkMobileSidebar'));
        e.preventDefault();
      }),
(a.prototype._toggleSubMenu = function (e) {
  var t = jQuery;             // keep style consistent with rest of file
  var $btn   = t(e.currentTarget);
  var $li    = $btn.closest('li');
  var $panel = $li.find('> .sidebar-nav__sub-links'); // direct child only

  // If no panel under this item, bail early
  if ($panel.length === 0) { e.preventDefault(); return; }

  var opening = !$panel.hasClass('is-active');

  // Ensure the container can host absolute children
  if (this.sidebarNav.css('position') === 'static') {
    this.sidebarNav.css('position', 'relative');
  }
  this.sidebarNav.css('overflow', 'hidden');

  // Close any open sibling panels (classic drilldown)
  $li.siblings().find('> .sidebar-nav__sub-links.is-active')
    .removeClass('is-active')
    .attr('aria-hidden', 'true')
    .data('open', false);

  // Toggle your plus icon
  $btn.find('.plus-button').toggleClass('plus-button--active', opening);

  // Mark associations for back-navigation/a11y (if you use a Back link)
  $panel.data('toggleBtn', $btn);
  $panel.data('ownerLi', $li);

  // Open/close via class only (CSS drives the slide)
  $panel
    .toggleClass('is-active', opening)
    .attr('aria-hidden', String(!opening))
    .data('open', opening);

  // Button a11y
  $btn.attr('aria-expanded', String(opening));

  // Kill native link navigation if your toggle is an <a>
  e.preventDefault();
  e.stopPropagation();
});


    (a.prototype._backFromSubMenu = function (e) {
    var $open = this.sidebarNav.find('.sidebar-nav__sub-links.is-active').last();
    if ($open.length === 0) return;

    // Try to find the opener button for a11y reset
    var $btn = $open.data('toggleBtn');
    if (!$btn || !$btn.length) {
        var $li = $open.data('ownerLi') || $open.closest('li');
        if ($li && $li.length) {
        $btn = $li.find('[data-action="toggle-mobile-sub-menu"]').first();
        }
    }

    $open.removeClass('is-active')
        .attr('aria-hidden', 'true')
        .data('open', false);

    if ($btn && $btn.length) {
        $btn.attr('aria-expanded', 'false');
        $btn.find('.plus-button').removeClass('plus-button--active');
        $btn.trigger('focus');
    }

    e.preventDefault();
    });



      (a.prototype._computeSidebarHeight = function () {
        var e = 0,
          i = this.header.outerHeight();
        if (this.announcementBar.length > 0) {
          var a = this.announcementBar.height(),
            o = t(window).height(),
            s = this.announcementBar[0].getBoundingClientRect();
          e = Math.max(
            0,
            s.top > 0 ? Math.min(a, o - s.top) : s.bottom < o ? s.bottom : o
          );
        }
        this.sidebarNav.css('max-height', window.innerHeight - i - e + 'px');
      }),
      (a.prototype._cursorFocus = function (t) {
        var e = window.scrollX,
          i = window.scrollY;
        t.focus(), window.scrollTo(e, i);
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
  })(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkProduct',
      i = 'plugin_' + e;
    function a(e, i) {
      (this.element = t(e)), this._init(i);
    }
    (a.prototype._init = function (e) {
      (this.product = e.product),
        (this.enableHistoryState = e.enableHistoryState),
        (this.optionsWithValues = e.optionsWithValues),
        (this.allowSelectingSoldOutVariants = e.allowSelectingSoldOutVariants),
        (this.singleOptionSelectors = this.element.find(
          '.single-option-selector'
        )),
        (this.dataSelectors = this.element
          .find('[data-selector-type]')
          .toArray()),
        (this.masterSelector = this.element.find(
          '#product-select-' + e.product.id
        )),
        (this.productSlides = this.element.find('.product__slides')),
        (this.productPrices = this.element.find('.product__prices')),
        (this.addToCartButton = this.element.find('.product__add-to-cart')),
        (this.quantitySelector = this.element.find('.quantity-selector')),
        (this.currentVariant = this._getVariantFromOptions()),
        this.singleOptionSelectors.on(
          'change',
          t.proxy(this._onSelectorChanged, this)
        ),
        this.quantitySelector
          .find('[data-action="decrease-product-quantity"]')
          .on('click', t.proxy(this._decreaseProductQuantity, this)),
        this.quantitySelector
          .find('[data-action="increase-product-quantity"]')
          .on('click', t.proxy(this._increaseProductQuantity, this)),
        this._getQuantityInput().on(
          'input change',
          t.proxy(this._onQuantityInputChange, this)
        ),
        this.singleOptionSelectors.next('label').on('keypress', function (e) {
          13 == (e.keyCode ? e.keyCode : e.which) && t(this).trigger('click');
        }),
        this.addToCartButton.on('click', t.proxy(this._addToCart, this)),
        this._updateQuantityButtons();
    }),
      (a.prototype.destroy = function () {
        this.singleOptionSelectors.off('change'),
          this.singleOptionSelectors.next('label').off('keypress'),
          this.addToCartButton.off('click'),
          this.quantitySelector
            .find('[data-action="decrease-product-quantity"]')
            .off('click'),
          this.quantitySelector
            .find('[data-action="increase-product-quantity"]')
            .off('click'),
          this._getQuantityInput().off('input change'),
          this.sidebarNav.off('.trademarkMobileSidebar');
        this.element.removeData('plugin_trademarkProduct');
      }),
      (a.prototype._getQuantityInput = function () {
        var t = this.quantitySelector.find('input[name="quantity"]');
        return t.length ? t : this.element.find('[name="quantity"]');
      }),
      (a.prototype._getQuantityValue = function () {
        var t = this._getQuantityInput(),
          e = parseInt(t.val(), 10),
          i = parseInt(t.attr('min'), 10),
          a = parseInt(t.attr('max'), 10),
          o = isNaN(i) ? 1 : i,
          n = isNaN(a) ? null : a,
          r = isNaN(e) ? o : e;
        return r < o && (r = o), null !== n && r > n && (r = n), r;
      }),
      (a.prototype._setQuantityValue = function (t) {
        var e = this._getQuantityInput();
        e.val(t),
          this.element
            .find('[name="quantity"]')
            .not(e)
            .val(t),
          this._updateQuantityButtons();
      }),
      (a.prototype._decreaseProductQuantity = function (t) {
        var e = this._getQuantityInput(),
          i = this._getQuantityValue(),
          a = parseInt(e.attr('min'), 10);
        isNaN(a) && (a = 1), i > a && this._setQuantityValue(i - 1), t.preventDefault();
      }),
      (a.prototype._increaseProductQuantity = function (t) {
        var e = this._getQuantityInput(),
          i = this._getQuantityValue(),
          a = parseInt(e.attr('max'), 10),
          o = i + 1;
        isNaN(a) || o <= a ? this._setQuantityValue(o) : this._setQuantityValue(a), t.preventDefault();
      }),
      (a.prototype._onQuantityInputChange = function () {
        this._setQuantityValue(this._getQuantityValue());
      }),
      (a.prototype._updateQuantityButtons = function () {
        var t = this._getQuantityInput(),
          e = this.quantitySelector.find(
            '[data-action="decrease-product-quantity"]'
          ),
          i = this.quantitySelector.find(
            '[data-action="increase-product-quantity"]'
          ),
          a = this._getQuantityValue(),
          o = parseInt(t.attr('min'), 10),
          n = parseInt(t.attr('max'), 10),
          r = !isNaN(o) ? o : 1,
          s = !isNaN(n) ? n : null,
          c = a <= r,
          l = null !== s && a >= s;
        e
          .toggleClass('is-disabled', c)
          .attr('aria-disabled', c ? 'true' : 'false'),
          i
            .toggleClass('is-disabled', l)
            .attr('aria-disabled', l ? 'true' : 'false');
      }),
      (a.prototype._onVariantChanged = function (t, e) {
        this._updateSlideshowImage(t, e),
          this._updateProductPrices(t, e),
          this._updateSelectors(t, e),
          this._updateAddToCartButton(t, e);
      }),
      (a.prototype._updateSlideshowImage = function (t, e) {
        e &&
          e.featured_image &&
          this.productSlides.slick(
            'slickGoTo',
            parseInt(
              this.productSlides
                .find('[data-image-id="' + e.featured_image.id + '"]')
                .attr('data-image-position')
            )
          );
      }),
      (a.prototype._updateProductPrices = function (e, i) {
        if (i) {
          if (
            e &&
            e.price === i.price &&
            e.compare_at_price === i.compare_at_price
          )
            return;
          this.productPrices.empty(),
            i.compare_at_price > i.price
              ? (this.productPrices.append(
                  '<span class="product__price product__price--new h4" data-money-convertible>' +
                    Shopify.formatMoney(i.price, window.shop.moneyFormat) +
                    '</span>'
                ),
                this.productPrices.append(
                  '<span class="product__price product__price--old h4" data-money-convertible>' +
                    Shopify.formatMoney(
                      i.compare_at_price,
                      window.shop.moneyFormat
                    ) +
                    '</span>'
                ))
              : this.productPrices.append(
                  '<span class="product__price h4" data-money-convertible>' +
                    Shopify.formatMoney(i.price, window.shop.moneyFormat) +
                    '</span>'
                ),
            this.productPrices.show().parent().show();
        } else
          this.productPrices.each(function (e, i) {
            var a = t(i).parent();
            a.hasClass('form__control') ? a.hide() : t(i).hide();
          });
      }),
      (a.prototype._updateSelectors = function (e, i) {
        if (i && !(this.product.options.length <= 1))
          for (
            var a = i.option1,
              o = i.option2,
              s = i.option3,
              n = this.product.variants.length,
              r = 0;
            r != this.dataSelectors.length;
            ++r
          )
            for (
              var d = t(this.dataSelectors[r]),
                l = d.attr('data-selector-type'),
                c = r + 1,
                h = this.optionsWithValues[r].values,
                p = 0;
              p != h.length;
              ++p
            ) {
              var u = h[p],
                f = !1,
                m = !1,
                g = !1;
              if (1 === c)
                for (var _ = 0; _ != n; ++_) {
                  if (
                    (y = this.product.variants[_]).option1 === u &&
                    y.option2 === o &&
                    y.option3 === s
                  ) {
                    (f = !0), (g = y.available);
                    break;
                  }
                }
              else if (2 === c)
                for (_ = 0; _ != n; ++_) {
                  if (
                    (y = this.product.variants[_]).option1 === a &&
                    y.option2 === u &&
                    y.option3 === s
                  ) {
                    (f = !0), (g = y.available);
                    break;
                  }
                }
              else if (3 === c)
                for (_ = 0; _ != n; ++_) {
                  var y;
                  if (
                    (y = this.product.variants[_]).option1 === a &&
                    y.option2 === o &&
                    y.option3 === u
                  ) {
                    (f = !0), (g = y.available);
                    break;
                  }
                }
              if (
                (f
                  ? (g || this.allowSelectingSoldOutVariants) && (m = !0)
                  : (m = !1),
                'size' === l)
              ) {
                var v = d.find('.product__size').eq(p);
                m
                  ? v
                      .removeClass('product__size--unavailable')
                      .find('> input')
                      .removeAttr('disabled')
                      .next('label')
                      .attr('tabindex', 0)
                  : v
                      .addClass('product__size--unavailable')
                      .find('> input')
                      .attr('disabled', 'disabled')
                      .next('label')
                      .removeAttr('tabindex');
              } else if ('color' === l) {
                var w = d.find('.product__color').eq(p);
                m
                  ? w
                      .removeClass('product__color--unavailable')
                      .find('> input')
                      .removeAttr('disabled')
                      .next('label')
                      .attr('tabindex', 0)
                  : w
                      .addClass('product__color--unavailable')
                      .find('> input')
                      .attr('disabled', 'disabled')
                      .next('label')
                      .removeAttr('tabindex');
              } else if ('select' === l) {
                var b = d.find('option').eq(p);
                m ? b.removeAttr('disabled') : b.attr('disabled', 'disabled');
              }
            }
      }),
      (a.prototype._updateAddToCartButton = function (t, e) {
        e
          ? e.available
            ? this.addToCartButton
                .removeAttr('disabled')
                .addClass('button--primary')
                .removeClass('button--secondary')
                .text(window.languages.productFormAddToCart)
            : this.addToCartButton
                .attr('disabled', 'disabled')
                .removeClass('button--primary')
                .addClass('button--secondary')
                .text(window.languages.productFormSoldOut)
          : this.addToCartButton
              .attr('disabled', 'disabled')
              .removeClass('button--primary')
              .addClass('button--secondary')
              .text(window.languages.productFormUnavailable);
      }),
      (a.prototype._onSelectorChanged = function () {
        var e = this.currentVariant;
        (this.currentVariant = this._getVariantFromOptions()),
          this._onVariantChanged(e, this.currentVariant),
          this.currentVariant &&
            (this.enableHistoryState &&
              this._updateHistoryState(this.currentVariant),
            this.masterSelector.find('[selected]').removeAttr('selected'),
            this.masterSelector
              .find('[value="' + this.currentVariant.id + '"]')
              .attr('selected', 'selected')),
          t(document).trigger('variant_changed.product', this.currentVariant);
      }),
      (a.prototype._updateHistoryState = function (t) {
        if (history.replaceState) {
          var e =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            t.id;
          window.history.replaceState({ path: e }, '', e);
        }
      }),
      (a.prototype._getVariantFromOptions = function () {
        var t = this._getCurrentOptions(),
          e = this.product.variants,
          i = !1;
        return (
          e.forEach(function (e) {
            var a = !0;
            t.forEach(function (t) {
              a && (a = t.value === e[t.index]);
            }),
              a && (i = e);
          }),
          i || null
        );
      }),
      (a.prototype._getCurrentOptions = function () {
        return this.singleOptionSelectors
          .toArray()
          .map(function (e) {
            var i = t(e),
              a = i.attr('type'),
              o = i.attr('data-option-index');
            return 'radio' === a || 'checkbox' === a
              ? !!i[0].checked && { value: i.val(), index: o }
              : { value: i.val(), index: o };
          })
          .filter(function (t) {
            return t;
          });
      }),
      (a.prototype._addToCart = function (e) {
        var i = this;
        this.addToCartButton
          .attr('disabled', 'disabled')
          .addClass('button--loading'),
          t
            .ajax({
              method: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: this.element.find('form[action^="/cart/add"]').serialize(),
            })
            .then(function (e) {
              jQuery('#curr_prod_title_cont').html(e.title);
              t
                .ajax({ method: 'GET', url: '/cart.js', dataType: 'json' })
                .then(function (e) {
                  i.addToCartButton
                    .removeAttr('disabled')
                    .removeClass('button--loading');
                });
            })
            .catch(function (t) {
              var e = t.responseJSON.description;
              i.addToCartButton
                .text(e)
                .removeAttr('disabled')
                .removeClass('button--loading'),
                setTimeout(function () {
                  i.addToCartButton.text(window.languages.productFormAddToCart);
                }, 2500);
            }),
          e.preventDefault();
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
  })(jQuery),
  (function (t) {
    'use strict';
    var e = 'trademarkTabs',
      i = 'plugin_' + e;
    function a(e, i) {
      (this.element = t(e)),
        (this.navItems = this.element.find('.tabs__nav-item')),
        (this.content = this.element.find('.tabs__content')),
        (this.contentItems = this.content.find('.tabs__content-item')),
        this.navItems.on('click', t.proxy(this._changeTab, this));
      var a = this.element.find('.tabs__nav-inner'),
        o = a.get(0);
      o.classList[
        o.scrollWidth - o.clientWidth - o.scrollLeft > 20 ? 'add' : 'remove'
      ]('tabs__nav-inner--shadowed-right'),
        a.on('scroll', function () {
          this.classList[this.scrollLeft > 20 ? 'add' : 'remove'](
            'tabs__nav-inner--shadowed-left'
          ),
            this.classList[
              this.scrollWidth - this.clientWidth - this.scrollLeft > 20
                ? 'add'
                : 'remove'
            ]('tabs__nav-inner--shadowed-right');
        });
    }
    (a.prototype.destroy = function () {
      this.navItems.off('click'),
        this.element.removeData('plugin_trademarkTabs');
    }),
      (a.prototype._changeTab = function (e) {
        var i = t(e.target),
          a = this.contentItems.filter('.tabs__content-item--active'),
          o = this.contentItems.eq(i.index()),
          s = this;
        this.content.css('height', a.height()),
          i
            .siblings()
            .removeClass('tabs__nav-item--active')
            .end()
            .addClass('tabs__nav-item--active'),
          a.removeClass('tabs__content-item--active'),
          o.addClass('tabs__content-item--active'),
          this.content.css('height', o.height()),
          Modernizr.cssanimations
            ? this.content.one('webkitAnimationEnd animationend', function () {
                s.content.css('height', '');
              })
            : this.content.css('height', ''),
          e.preventDefault();
      }),
      (t.fn[e] = function (e) {
        var o = !1,
          s = arguments;
        return (
          'string' == typeof e && (o = e),
          this.each(function () {
            var n = t.data(this, i);
            n || o
              ? o && callMethod(n, o, Array.prototype.slice.call(s, 1))
              : t.data(this, i, new a(this, e));
          })
        );
      });
})(jQuery);

var router = new RouterRouter();
router.route('*all', function () {
  var t,
    e,
    i,
    a,
    o = $('body');
  (t = $('.shopify-section__header')),
    $('.anchor').css('top', -t.height()),
    $('.sidebar-nav').trademarkMobileSidebar(),
    $(document).on(
      'shopify:section:unload',
      '#shopify-section-header',
      function (t) {
        $(t.target)
          .find('.sidebar-nav')
          .data('plugin_trademarkMobileSidebar')
          .destroy();
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-header',
      function (t) {
        $(t.target).find('.sidebar-nav').trademarkMobileSidebar();
      }
    ),
    $('.header__main-nav').trademarkMainNav(),
    $(document).on(
      'shopify:section:unload',
      '#shopify-section-header',
      function (t) {
        $(t.target)
          .find('.header__main-nav')
          .data('plugin_trademarkMainNav')
          .destroy();
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-header',
      function (t) {
        $(t.target).find('.header__main-nav').trademarkMainNav();
      }
    ),
    $('.mini-cart').trademarkMiniCart(),
    $(document).on(
      'shopify:section:unload',
      '#shopify-section-header',
      function (t) {
        $(t.target)
          .find('.mini-cart')
          .data('plugin_trademarkMiniCart')
          .destroy();
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-header',
      function (t) {
        $(t.target).find('.mini-cart').trademarkMiniCart();
      }
    ),
    $('.header-search').trademarkHeaderSearch(),
    $(document).on(
      'shopify:section:unload',
      '#shopify-section-header',
      function (t) {
        $(t.target)
          .find('.header-search')
          .data('plugin_trademarkHeaderSearch')
          .destroy();
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-header',
      function (t) {
        $(t.target).find('.header-search').trademarkHeaderSearch();
      }
    ),
    (function () {
      $('.rte table')
        .addClass('table')
        .wrap('<div class="table-wrapper"></div>');
      var t = $(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
        ),
        e = t.add('.rte iframe#admin_bar_iframe');
      t.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
      }),
        e.each(function () {
          this.src = this.src;
        });
    })(),
    (Modernizr.touchevents && !Modernizr.mq('(min-width: 1024px)')) ||
      o.on('mouseenter mouseleave', '.collection-item', function () {
        $(this)
          .toggleClass('collection-item--hovered')
          .find('.collection-item__bottom')
          .slideToggle({ duration: 250 });
      }),
    (e = function (t) {
      if (0 !== t.length) {
        var e, i, a, o, s, n;
        window.twttr =
          ((e = document),
          (i = 'script'),
          (a = 'twitter-wjs'),
          (s = e.getElementsByTagName(i)[0]),
          (n = window.twttr || {}),
          e.getElementById(a) ||
            (((o = e.createElement(i)).id = a),
            (o.src = 'https://platform.twitter.com/widgets.js'),
            s.parentNode.insertBefore(o, s),
            (n._e = []),
            (n.ready = function (t) {
              n._e.push(t);
            })),
          n);
        var r = t.attr('data-twitter-handle');
        twttr.ready(function () {
          twttr.widgets
            .createTimeline(
              { sourceType: 'profile', screenName: r },
              document.getElementById('twitter-timeline'),
              {
                tweetLimit: 1,
                lang: window.shop.locale || 'en',
                chrome: 'noheader nofooter noborders transparent noscrollbar',
              }
            )
            .then(function (t) {
              var e = $(t).contents(),
                i = $('.tweet');
              i.find('.tweet__content').html(e.find('.timeline-Tweet-text')),
                i
                  .find('.tweet__date')
                  .text(
                    e
                      .find('.timeline-Tweet-timestamp .dt-updated')
                      .attr('aria-label')
                  );
            });
        });
      }
    })($('.footer [data-twitter-handle]')),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-footer',
      function (t) {
        e($(t.target).find('[data-twitter-handle]'));
      }
    ),
    (i = null),
    (a = function (t) {
      0 === t.length ||
        Modernizr.mq('(max-width: 559px)') ||
        ((i = t.remodal({
          hashTracking: !0,
          appendTo: '#shopify-section-popup',
        })),
        setTimeout(function () {
          'closed' !== i.getState() ||
            $.cookie('theme_popup_seen') ||
            'true' !== t.attr('data-visible') ||
            i.open(),
            $.cookie('theme_popup_seen', !0, {
              expires: parseInt(t.attr('data-remember-me')),
            });
        }, parseInt(t.attr('data-delay'))));
    })($('.promotion-popup')),
    $(document).on(
      'shopify:section:select',
      '#shopify-section-popup',
      function () {
        i && 'opened' !== i.getState() && i.open();
      }
    ),
    $(document).on(
      'shopify:section:deselect',
      '#shopify-section-popup',
      function () {
        i && i.close();
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-popup',
      function (t) {
        a($(t.target).find('.promotion-popup'));
      }
    );
}),
  router.route('blogs/*blog/*article', function () {
    var t, e;
    objectFitImages(),
      (t = $('#shopify-section-header')),
      (e = $('.article__body .share-buttons')).css('top', t.height() + 20),
      e.Stickyfill();
  }),
  router.route('blogs/*blog', function () {
    objectFitImages();
  }),
  router.route('cart', function () {
    var t, e;
    $('.cart__note').on('change', function () {
      $.ajax({
        method: 'POST',
        url: '/cart/update.js',
        data: { note: $(this).val() },
        dataType: 'json',
      });
    }),
      (t = function () {
        var t = $('.shipping-estimator');
        if (0 !== t.length) {
          var e = t.find('.shipping-estimator__form'),
            i = t.find('.shipping-estimator__submit'),
            a = t.find('.shipping-estimator__results'),
            o = a.find('.shipping-estimator__list'),
            s = $('.cart__shipping');
          $('.shipping-estimator--mobile .shipping-estimator__title').on(
            'click',
            function () {
              $(this).next('.shipping-estimator__inner').slideToggle(),
                $(this)
                  .closest('.shipping-estimator')
                  .toggleClass('shipping-estimator--active');
            }
          );
          var n = function (t) {
            i.text(window.languages.shippingEstimatorSubmitting),
              $.ajax({
                method: 'GET',
                url: '/cart/shipping_rates.json',
                data: $(t.currentTarget)
                  .closest('.shipping-estimator__form')
                  .find('input, select')
                  .serialize(),
                success: function (t) {
                  if (
                    (o.empty(),
                    t.shipping_rates.forEach(function (t) {
                      var e = Shopify.formatMoney(
                        100 * t.price,
                        window.shop.moneyFormat
                      );
                      o.append(
                        '<li class="shipping-estimator__item">' +
                          t.name +
                          ': <span data-money-convertible>' +
                          e +
                          '</span></li>'
                      );
                    }),
                    t.shipping_rates.length > 0)
                  ) {
                    var e = Shopify.formatMoney(
                      100 * t.shipping_rates[0].price,
                      window.shop.moneyFormat
                    );
                    s.html(window.languages.cartEstimatedShipping + ' ' + e);
                  }
                },
                error: function (t) {
                  o.empty();
                  var e = t.responseJSON,
                    i = [];
                  for (var a in e)
                    e.hasOwnProperty(a) && i.push({ key: a, value: e[a][0] });
                  i.forEach(function (t) {
                    o.append(
                      '<li class="shipping-estimator__item">' +
                        t.key +
                        ': ' +
                        t.value +
                        '</li>'
                    );
                  });
                },
                complete: function (t) {
                  i.html(window.languages.shippingEstimatorSubmit), a.show();
                },
              }),
              t.preventDefault();
          };
          e.on('keypress', function (t) {
            13 == t.keyCode && n(t);
          }),
            $('.shipping-estimator__submit').on('click', function (t) {
              n(t);
            }),
            new Shopify.CountryProvinceSelector(
              'address_country',
              'address_province',
              { hideElement: 'address_province_container' }
            ),
            new Shopify.CountryProvinceSelector(
              'address_country_mobile',
              'address_province_mobile',
              { hideElement: 'address_province_container_mobile' }
            );
        }
      })(),
      $(document).on(
        'shopify:section:load',
        '#shopify-section-cart-template',
        function () {
          t();
        }
      ),
      (e = function (t) {
        0 !== t.length &&
          t.slick({
            accessibility: !1,
            dots: !0,
            dotsClass: 'slider-dots',
            arrows: !1,
            adaptiveHeight: !0,
            mobileFirst: !0,
            infinite: !1,
            centerMode: !0,
            centerPadding: '32px',
            slidesToShow: 1,
            initialSlide: Math.ceil(t.attr('data-slides-count') / 2) - 1,
            responsive: [{ breakpoint: 560, settings: 'unslick' }],
          });
      })($('.list-products')),
      $(document).on(
        'shopify:section:unload',
        '.shopify-section__cart-related-products',
        function (t) {
          $(t.target).find('.list-products').slick('unslick');
        }
      ),
      $(document).on(
        'shopify:section:load',
        '.shopify-section__cart-related-products',
        function (t) {
          e($(t.target).find('.list-products'));
        }
      ),
      $(window).on('resize orientationChange', function () {
        if (window.innerWidth < 560) {
          var t = $('.list-products');
          t.slick('getSlick').unslicked && e(t);
        }
      });
  }),
  router.route('collections/*type', function () {
    objectFitImages(),
      (function () {
        Shopify.queryParams = {};
        var t = function () {
          if (
            ($('#collection-sort-by')
              .val(window.shop.collectionSortBy)
              .on('change', function () {
                (Shopify.queryParams.sort_by = $(this).val()),
                  (location.search = $.param(Shopify.queryParams));
              }),
            location.search.length)
          )
            for (
              var t, e = 0, i = location.search.substr(1).split('&');
              e < i.length;
              e++
            )
              (t = i[e].split('=')).length > 1 &&
                (Shopify.queryParams[decodeURIComponent(t[0])] =
                  decodeURIComponent(t[1]));
          $('#collection-tag-filter, #collection-type-filter').on(
            'change',
            function (t) {
              window.location.href = $(t.currentTarget).find(':selected').val();
            }
          );
        };
        t(),
          $(document).on('shopify:section:load', function (e) {
            t();
          });
      })(),
      $('#instafeed').trademarkInstagram(),
      $(document).on(
        'shopify:section:unload',
        '#shopify-section-collection-template',
        function (t) {
          $(t.target)
            .find('#instafeed')
            .data('plugin_trademarkInstagram')
            .destroy();
        }
      ),
      $(document).on(
        'shopify:section:load',
        '#shopify-section-collection-template',
        function (t) {
          $(t.target).find('#instafeed').trademarkInstagram();
        }
      );
  }),
  router.route('gift_cards/*id', function () {
    var t, e, i;
    (t = '#PrintGiftCard'),
      (e = '#GiftCardDigits'),
      (i = $('#QrCode')),
      new QRCode(i[0], {
        text: i.attr('data-identifier'),
        width: 175,
        height: 175,
      }),
      $(t).on('click', function () {
        window.print();
      }),
      $(e).on('click', { element: 'GiftCardDigits' }, function (t) {
        var e = document.getElementById(t.data.element),
          i = '';
        if (document.body.createTextRange)
          (i = document.body.createTextRange()).moveToElementText(e),
            i.select();
        else if (window.getSelection) {
          var a = window.getSelection();
          (i = document.createRange()).selectNodeContents(e),
            a.removeAllRanges(),
            a.addRange(i);
        }
      });
  }),
  router.route('', function () {
    var t, e;
    !(function () {
      objectFitImages();
      var t = function (t) {
        var e = t.next('.fs-slideshow__slide-count'),
          i = t
            .nextAll('.fs-slideshow__progress-bar')
            .find('.fs-slideshow__progress-bar-advancement');
        t.slick({
          dots: !1,
          arrow: !0,
          pauseOnHover: !1,
          accessibility: !1,
          adaptiveHeight: !0,
          useTransform: !0,
          useCSS: !0,
          autoplay: 'true' === t.attr('data-autoplay'),
          autoplaySpeed: parseInt(t.attr('data-cycle-speed')),
          prevArrow:
            '<button class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
          nextArrow:
            '<button class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
        });
        var playResponsiveVideos = function (slide) {
            slide.find('.fs-slideshow__video:visible').each(function () {
              var t = this.play();
              t && 'function' == typeof t.catch && t.catch(function () {});
            });
          },
          pauseResponsiveVideos = function (slide) {
            slide.find('.fs-slideshow__video').each(function () {
              this.pause();
            });
          },
          sendYouTubeCommand = function (slide, command) {
            slide.find('.fs-slideshow__youtube-iframe:visible').each(function () {
              this.contentWindow &&
                this.contentWindow.postMessage(
                  JSON.stringify({
                    event: 'command',
                    func: command,
                    args: [],
                  }),
                  '*'
                );
            });
          },
          playResponsiveYouTube = function (slide) {
            sendYouTubeCommand(slide, 'playVideo');
          },
          pauseResponsiveYouTube = function (slide) {
            sendYouTubeCommand(slide, 'pauseVideo');
          },
          syncResponsiveVideos = function (activeSlide) {
            t.find('.fs-slideshow__slide').each(function () {
              pauseResponsiveVideos($(this)),
                pauseResponsiveYouTube($(this));
            }),
              playResponsiveVideos(activeSlide),
              playResponsiveYouTube(activeSlide);
          };
        t
          .find('.fs-slideshow__video')
          .each(function () {
            this.muted = !0;
            this.defaultMuted = !0;
            this.controls = !1;
          }),
          syncResponsiveVideos(t.find('.fs-slideshow__slide:visible').first());
        var a =
          plyr.setup(t.find('.plyr-video[data-type]'), {
            controls: ['play-large'],
            iconPrefix: 'icon-video',
          }) || [];
        a.forEach(function (e) {
          e.on('play', function () {
            t.closest('.fs-slideshow').addClass('fs-slideshow--video-playing'),
              t.slick('pause');
          }),
            e.on('pause ended', function () {
              t
                .closest('.fs-slideshow')
                .removeClass('fs-slideshow--video-playing'),
                t.slick('play');
            });
        }),
          t.on('beforeChange', function (t, e, i, o) {
            pauseResponsiveVideos($(e.$slides.get(i)));
            a.forEach(function (t) {
              t.pause();
            });
          }),
          t.on('afterChange', function (t, a, o) {
            syncResponsiveVideos($(a.$slides.get(o))),
            e.length > 0 && e.find('.fs-slideshow__current-slide').text(o + 1),
              i.length > 0 &&
                i.css('width', ((o + 1) / a.slideCount) * 100 + '%');
          }),
          $(window).on('resize orientationchange', function () {
            syncResponsiveVideos(t.find('.fs-slideshow__slide:visible').first());
          });
      };
      $('.slideshow-section').each(function (e, i) {
        var a = $(i);
        'dual' === a.attr('data-slideshow-type')
          ? a.find('.dual-slideshow').trademarkHomeSlideshow()
          : t(a.find('.fs-slideshow__slides'));
      }),
        $(document).on(
          'shopify:section:unload',
          '.shopify-section__slideshow',
          function (t) {
            var e = $(t.target).find('.slideshow-section');
            'dual' === e.attr('data-slideshow-type')
              ? e
                  .find('.dual-slideshow')
                  .data('plugin_trademarkHomeSlideshow')
                  .destroy()
              : e.find('.fs-slideshow__slides').slick('unslick');
          }
        ),
        $(document).on(
          'shopify:section:load',
          '.shopify-section__slideshow',
          function (e) {
            var i = $(e.target).find('.slideshow-section');
            if ('dual' === i.attr('data-slideshow-type'))
              i.find('.dual-slideshow').trademarkHomeSlideshow();
            else {
              var a = i.find('.fs-slideshow__slides');
              t(a);
            }
          }
        ),
        $(document).on(
          'shopify:block:select',
          '.shopify-section__slideshow',
          function (t) {
            var e,
              i = $(t.target).closest('.slideshow-section');
            'dual' === i.attr('data-slideshow-type')
              ? ((e = i
                  .find('.dual-slideshow')
                  .data('plugin_trademarkHomeSlideshow')).pause(),
                e.goToSlide($(t.target).attr('data-slide-index')))
              : ((e = i.find('.fs-slideshow__slides')).slick(
                  'goTo',
                  $(t.target).attr('data-slide-index')
                ),
                'true' === e.attr('data-autoplay') && e.slick('pause'));
          }
        ),
        $(document).on(
          'shopify:block:deselect',
          '.shopify-section__slideshow',
          function (t) {
            var e = $(t.target).closest('.slideshow-section');
            if ('dual' === e.attr('data-slideshow-type'))
              e.find('.dual-slideshow')
                .data('plugin_trademarkHomeSlideshow')
                .play();
            else {
              var i = e.find('.fs-slideshow__slides');
              'true' === i.attr('data-autoplay') && i.slick('play');
            }
          }
        );
    })(),
      !(function () {
        var initHomepageUspSlider = function (slider) {
            var shouldInitSlider = window.innerWidth < 1025,
              slideCount = slider.children().length,
              slidesToShow = slideCount > 3 ? 3 : 1;

            if (!slider.length) {
              return;
            }

            if (!shouldInitSlider) {
              slider.hasClass('slick-initialized') && slider.slick('unslick');
              return;
            }

            if (slider.hasClass('slick-initialized')) {
              return;
            }

            slider.slick({
              accessibility: !1,
              arrows: !1,
              dots: !1,
              infinite: !0,
              autoplay: !0,
              autoplaySpeed: 60,
              speed: 8000,
              cssEase: 'linear',
              pauseOnHover: !1,
              pauseOnFocus: !1,
              variableWidth: !0,
              swipe: !1,
              swipeToSlide: !1,
              touchMove: !1,
              draggable: !1,
              waitForAnimate: !1,
              slidesToShow: slidesToShow,
              slidesToScroll: 1,
            });
          },
          resumeHomepageUspSliders = function () {
            $('[data-usp-slider].slick-initialized').each(function (e, slider) {
              slider = $(slider);
              slider.slick('setPosition');
              slider.slick('slickPlay');
            });
          },
          handleHomepageUspSliders = function (context) {
            $(context)
              .find('[data-usp-slider]')
              .each(function (t, e) {
                initHomepageUspSlider($(e));
              });
          };

        handleHomepageUspSliders(document),
          $(document).on(
            'shopify:section:unload',
            '.shopify-section__prodfeatcapabilities',
            function (t) {
              $(t.target).find('[data-usp-slider]').each(function (e, slider) {
                slider = $(slider);
                slider.hasClass('slick-initialized') && slider.slick('unslick');
              });
            }
          ),
          $(document).on(
            'shopify:section:load',
            '.shopify-section__prodfeatcapabilities',
            function (t) {
              handleHomepageUspSliders(t.target);
            }
          ),
          $(window).on('resize orientationChange', function () {
            handleHomepageUspSliders(document);
          }),
          $(window).on('pageshow', function () {
            handleHomepageUspSliders(document);
            resumeHomepageUspSliders();
          }),
          $(document).on('visibilitychange', function () {
            if ('visible' === document.visibilityState) {
              handleHomepageUspSliders(document);
              resumeHomepageUspSliders();
            }
          });
      })(),
      (t = function (t) {
        0 !== t.length &&
          t.slick({
            accessibility: !1,
            dots: !0,
            dotsClass: 'slider-dots',
            arrows: !1,
            mobileFirst: !0,
            infinite: !1,
            centerMode: !0,
            centerPadding: '32px',
            initialSlide: Math.ceil(t.attr('data-slides-count') / 2) - 1,
            slidesToShow: 1,
            responsive: [{ breakpoint: 560, settings: 'unslick' }],
          });
      })($('.list-collections')),
      $(document).on(
        'shopify:section:unload',
        '.shopify-section__collection-list',
        function (t) {
          $(t.target).find('.list-collections').slick('unslick');
        }
      ),
      $(document).on(
        'shopify:section:load',
        '.shopify-section__collection-list',
        function (e) {
          t($(e.target).find('.list-collections'));
        }
      ),
      $(document).on(
        'shopify:block:select',
        '.shopify-section__collection-list',
        function (t) {
          $(t.target)
            .closest('.list-collections')
            .slick('slickGoTo', $(t.target).attr('data-slide-index'));
        }
      ),
      $(window).on('resize orientationChange', function () {
        if (window.innerWidth < 560) {
          var e = $('.list-collections');
          e.slick('getSlick').unslicked && t(e);
        }
      }),
      (e = function (t) {
        0 !== t.length &&
          t.slick({
            accessibility: !1,
            dots: !0,
            dotsClass: 'slider-dots',
            arrows: !1,
            adaptiveHeight: !0,
            mobileFirst: !0,
            infinite: !1,
            centerMode: !0,
            centerPadding: '32px',
            slidesToShow: 1,
            initialSlide: Math.ceil(t.attr('data-slides-count') / 2) - 1,
            responsive: [{ breakpoint: 560, settings: 'unslick' }],
          });
      })($('.list-products')),
      $(document).on(
        'shopify:section:unload',
        '.shopify-section__featured-collection',
        function (t) {
          $(t.target).find('.list-products').slick('unslick');
        }
      ),
      $(document).on(
        'shopify:section:load',
        '.shopify-section__featured-collection',
        function (t) {
          e($(t.target).find('.list-products'));
        }
      ),
      $(window).on('resize orientationChange', function () {
        if (window.innerWidth < 560) {
          var t = $('.list-products');
          t.slick('getSlick').unslicked && e(t);
        }
      }),
      $('#instafeed').trademarkInstagram(),
      $(document).on(
        'shopify:section:unload',
        '.shopify-section__instagram',
        function (t) {
          $(t.target)
            .find('#instafeed')
            .data('plugin_trademarkInstagram')
            .destroy();
        }
      ),
      $(document).on(
        'shopify:section:load',
        '.shopify-section__instagram',
        function (t) {
          $(t.target).find('#instafeed').trademarkInstagram();
        }
      );
  }),
  router.route('account/login', function () {
    var t;
    (t = function () {
      $('#login-section, #recover-password-section').toggle(),
        $('.page__title').text(window.languages.recoverPasswordTitle);
    }),
      $('[data-action="display-recover-form"]').on('click', function () {
        return t(), !1;
      }),
      ('#recover' !== window.location.hash && !0 !== window.recoverPassword) ||
        t();
  }),
  router.route('password', function () {
    var t;
    (t = $('.password-popup')),
      $('[data-action="toggle-storefront-password"]').on('click', function () {
        t.remodal({ hashTracking: !1 }).open();
      });
  });
var productRoute = function () {
  var t, e, i;
  (t = function (t) {
    if (0 !== t.length) {
      var e = t,
        i = e.find('.product__slides'),
        a = t.find('.product__thumbnails');
      i.slick({
        adaptiveHeight: !1,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: parseInt(i.attr('data-initial-slide')),
        prevArrow:
          '<div class="ps-slick-arrow ps-slick-prev"><svg class="icon icon-arrow-left" aria-hidden="true"><use xlink:href="#icon-arrow-left"></use></svg></div>',
        nextArrow:
          '<div class="ps-slick-arrow ps-slick-next"><svg class="icon icon-arrow-right" aria-hidden="true"><use xlink:href="#icon-arrow-right"></use></svg></div>',
        dots: !1,
        fade: !1,
        asNavFor: '.product__thumbnails',
      }),
        $('.product__thumbnails').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.product__slides',
          arrows: !1,
          dots: !1,
          focusOnSelect: !0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 6
              }
            }
          ]
        }),
        i.on('beforeChange', function (t, e, i, o) {
          a.find('.product__thumbnail')
            .removeClass('product__thumbnail--active')
            .eq(o)
            .addClass('product__thumbnail--active');
        }),
        a.find('.product__thumbnail').on('click', function (t) {
          var e = $(this);
          e.addClass('product__thumbnail--active'),
            e.siblings().removeClass('product__thumbnail--active'),
            i.slick('slickGoTo', $(this).attr('data-slide-index')),
            t.preventDefault();
        }),
        'true' === e.attr('data-enable-image-zoom') &&
          Modernizr.mq('(min-width: 801px)') &&
          i.magnificPopup({
            delegate: '.product__slide',
            type: 'image',
            gallery: {
              enabled: !0,
              arrowMarkup:
                '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg class="icon icon-arrow-%dir% mfp-prevent-close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-%dir%"></use></svg></button>',
            },
          });
    }
  })($('.product__slideshow')),
    $(document).on(
      'shopify:section:unload',
      '#shopify-section-product-template',
      function (t) {
        $(t.target).find('.product__slides').slick('unslick'),
          $(t.target).find('.product__thumbnail').off('click');
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-product-template',
      function (e) {
        t($(e.target).find('.product__slideshow'));
      }
    ),
    (e = function (t) {
      0 !== t.length && t.trademarkTabs();
    })($('.product__tabs')),
    $(document).on(
      'shopify:section:unload',
      '#shopify-section-product-template',
      function (t) {
        $(t.target)
          .find('.product__tabs')
          .data('plugin_trademarkTabs')
          .destroy();
      }
    ),
    $(document).on(
      'shopify:section:load',
      '#shopify-section-product-template',
      function (t) {
        e($(t.target).find('.product__tabs'));
      }
    ),
    (i = function (t) {
      0 !== t.length &&
        t.slick({
          accessibility: !1,
          dots: !0,
          dotsClass: 'slider-dots',
          arrows: !1,
          adaptiveHeight: !0,
          mobileFirst: !0,
          infinite: !1,
          centerMode: !0,
          centerPadding: '32px',
          slidesToShow: 1,
          initialSlide: Math.ceil(t.attr('data-slides-count') / 2) - 1,
          responsive: [{ breakpoint: 560, settings: 'unslick' }],
        });
    })($('.list-products')),
    $(document).on('shopify:section:unload', function (t) {
      $(t.target).find('.list-products').slick('unslick');
    }),
    $(document).on('shopify:section:load', function (t) {
      i($(t.target).find('.list-products'));
    }),
    $(window).on('resize orientationChange', function () {
      if (window.innerWidth < 560) {
        var t = $('.list-products');
        t.slick('getSlick').unslicked && i(t);
      }
    });
};
jQuery(document).ready(function (t) {
  jQuery.getJSON(
    'https://vegepodaus.myshopify.com/products.json',
    function (t) {
      jQuery.each(t.products, function (e) {
        jQuery.each(t.products[e].tags, function (t, e) {});
      });
    }
  ),
    jQuery('body').on('click', 'a.atc-this', function (e) {
      e.preventDefault();
      var i = jQuery(this),
        a = jQuery(this).attr('href');
      i.addClass('button--loading'),
        jQuery.post('/cart/add.js', { quantity: 1, id: a }).done(function (e) {
          i.removeClass('button--loading'),
            t(
              "<p class='success-this'>This Item has been added to your cart.</p>"
            ).insertBefore(i),
            setTimeout(function () {
              t('.success-this').remove();
            }, 2e3),
            t('.success-this')
              .filter(function () {
                return (
                  'This Item has been added to your cart.' === this.textContent
                );
              })
              .slice(0, -1)
              .remove(),
            t
              .ajax({ method: 'GET', url: '/cart.js', dataType: 'json' })
              .then(function (e) {
                t(document).trigger('theme:cart:updated', [e, !1, !0]);
              });
        });
    }),
    (prod_handle = t.trim(t('#prod_handle_cont').text())),
    prod_handle &&
      t('.upsell_cont_inside .prod_item').length &&
      jQuery.getJSON('/products/' + prod_handle + '.js', function (t) {
        (get_prod_id = t.id),
          console.log('prod_id ' + get_prod_id),
          jQuery.each(t.tags, function (t, e) {
            console.log('product tag: ' + e), (get_size = e);
          });
        var e = !1;
        jQuery.getJSON(
          'https://vegepodaus.myshopify.com/products.json?limit=150',
          function (t) {
            jQuery.each(t.products, function (i) {
              -1 == t.products[i].tags.indexOf('wholesale_only') &&
                t.products[i].id != get_prod_id &&
                jQuery.each(t.products[i].tags, function (a, o) {
                  o == get_size &&
                    (e ||
                      (jQuery('.upsell_header').append(
                        '<h5 class="might_like">You might also like</h5>'
                      ),
                      (e = !0)),
                    0 ===
                      jQuery('.upsell_cont_inside .prod_item').find('.flex-this')
                        .length &&
                      jQuery.getJSON(
                        '/products/' + t.products[i].handle + '.js',
                        function (t) {
                          var e = '$' + parseFloat(t.price / 100).toFixed(2),
                            i = t.variants[0].id,
                            a = '<div class="var-class var-' + i + '">';
                          (a += '<div class="flex-this">'),
                            (a +=
                              '<a href="' +
                              t.url +
                              '"><p class="img-this"><img src="' +
                              t.featured_image +
                              '" alt="image" /></p></a>'),
                            (a += '<span class="right-content">'),
                            (a +=
                              '<a href="' +
                              t.url +
                              '"><h3 class="title-this">' +
                              t.title +
                              '</h3></a>'),
                            (a +=
                              '<a href="' +
                              t.url +
                              '"><p class="price-this">' +
                              e +
                              '</p></a>'),
                            (a +=
                              '<a href="' +
                              i +
                              '" class="atc-this" id="atc-this-btn">ADD TO CART</a>'),
                            (a += '</span>'),
                            (a += '</div></div>'),
                            jQuery('.upsell_cont_inside .prod_item').prepend(a);
                        }
                      ));
                });
            });
          }
        );
      });
}),
  router.route('products/*type', productRoute),
  router.route('collections/*collection/products/*type', productRoute),
  router.route('products_preview', productRoute);
var tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
var player,
  firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var ytLoader = [];
function onYouTubeIframeAPIReady() {
  $('.js-videoWrapper .js-videoIframe').each(function () {
    ytLoader[$(this).attr('id')] = new YT.Player($(this).attr('id'), {
      height: '390',
      width: '640',
      videoId: $(this).data('video-id'),
      playerVars: { rel: 0, showinfo: 0 },
      events: { onReady: onPlayerReady, onStateChange: onPlayerStateChange },
    });
  });
}
function onPlayerReady(t) {}
var done = !1;
function onPlayerStateChange(t) {
  console.log(t), t.data, t.data;
}
function stopVideo() {
  player.stopVideo();
}
function errorCartAdditional(t) {
  $(document).on('click', '.cart__checkout-button', function (e) {
    ('' !== t.value && t.value.replace(/\s/g, '').length) ||
      (e.preventDefault(),
      t.removeAttribute('style'),
      t.setAttribute('style', 'border-color: red'),
      setTimeout(function () {
        t.removeAttribute('style');
      }, 5e3));
  });
}
$(document).on('click', '.js-videoPoster', function (t) {
  t.preventDefault();
  var e = $(this).closest('.js-videoWrapper');
  e.addClass('videoWrapperActive'),
    ytLoader[e.find('.js-videoIframe').attr('id')].playVideo();
}),
  errorCartAdditional(document.getElementById('headAboutOther')),
  $(document).on('change', '.cart__refer #option-value', function (t) {
    const e = document.getElementById('headAboutOther');
    'Other' === $(this).val()
      ? errorCartAdditional(e)
      : (e.value = $(this).val());
  });

  

  
